<template>
  <div>
    <el-table highlight-current-row  ref="multiTable" @cell-click="cellClick" :data="msinForm.msin_mtrl_list" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="48" align="center"></el-table-column>
      <el-table-column label="物料编号">
        <template slot-scope="scope">
          <el-form-item label-width="0" :prop="'msin_mtrl_list.'+scope.$index+'.mtrl_no'">
            <el-input :disabled="true" v-model="msinForm.msin_mtrl_list[scope.$index].mtrl_no" maxlength="10" show-word-limit placeholder="暂无物料编号"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="物料名称">
        <template slot-scope="scope">
          <el-form-item label-width="0" :prop="'msin_mtrl_list.'+scope.$index+'.mtrl_name'">
            <el-input :disabled="true" v-model="msinForm.msin_mtrl_list[scope.$index].mtrl_name" maxlength="30" show-word-limit placeholder="暂无物料名称"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="物料单位">
        <template slot-scope="scope">
          <el-form-item label-width="0" :prop="'msin_mtrl_list.'+scope.$index+'.mtrl_unit'">
            <el-input disabled v-model="msinForm.msin_mtrl_list[scope.$index].mtrl_unit" maxlength="30" show-word-limit placeholder="暂无产品规格"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot="header">
          <span class="vg_deep_red">入库数量</span>
        </template>
        <template slot-scope="scope">
          <el-form-item label-width="0" :prop="'msin_mtrl_list.'+scope.$index+'.msin_mtrl_num'" :rules="[{required:true}]">
            <el-input  show-word-limit maxlength="13" v-model="msinForm.msin_mtrl_list[scope.$index].msin_mtrl_num" placeholder="暂无入库数量"></el-input> 
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot="header">
          <span class="vg_deep_red">库位</span>
        </template>
        <template slot-scope="scope">
          <el-form-item label-width="0" :prop="'msin_mtrl_list.'+scope.$index+'.mstk_bin'" :rules="[{required:true}]">
            <el-select v-model="msinForm.msin_mtrl_list[scope.$index].mstk_bin" placeholder="暂无产品类型" clearable>
              <el-option
                  v-for="item in mtrlLocation"
                  :key="item.id"
                  :label="item.param1"
                  :value="item.param1">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="待入库数量">
        <template slot-scope="scope">
          <el-form-item label-width="0" :prop="'msin_mtrl_list.'+scope.$index+'.stay_mpin_num'" >
            <el-input show-word-limit disabled v-model="msinForm.msin_mtrl_list[scope.$index].stay_mpin_num" placeholder="暂无入库数量"></el-input> 
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {get,post} from "@api/request";
import {optnAPI} from "@api/modules/optn";

export default {
  name:"MtrlAddMtrl",
  props:{
    msinForm:{
      type: Object,
      required:true,
    }
  },
  data(){
    return {
      selectionsList:[],
      // tableHeight:269,
      mtrlTypeGroupOpt:[],
      mtrlLocation:[],
      formatNumber:null
    }
  },
  created(){
    this.initData()
  },
  methods:{
    initData(){
      this.getSmplType()
      this.getLocation()
    },
    // 获取玩具类型
    getSmplType(flag){
      get(optnAPI.getAllContent,{perm_id : 10003})
      .then(res=>{
        if(res.data.code === 0) {
          this.mtrlTypeGroupOpt = res.data.data;
        }
      })
    },
    // 获取库位
    getLocation(){
      get(optnAPI.getAllContent,{perm_id : 10006})
      .then(res=>{
        if(res.data.code === 0) {
          this.mtrlLocation = res.data.data;
        }
      })
    },
    // 清空
    clear(){
      this.$refs.multiTable.clearSelection();
      this.multiSelection = null
    },
    //产品信息选择框
    handleSelectionChange(selection) {
      this.selectionsList = [];
      this.selectionsList = selection
      this.$emit("handleSelectionChange",this.selectionsList)
    },
    // 单选信息格的时候
    cellClick(val){
      this.$emit("cellClick",val)
    },  
    formatNum(scope){
      console.log(scope)
    },
  },
}
</script>

<style scoped>

</style>>
